import { ButtonHTMLAttributes, useEffect, useState } from 'react';
import { isMobile, osName } from 'react-device-detect';
import { PWAInstructionModal } from 'components/modals/PWAInstructionModal';
import { useIsPWA } from 'hooks/usePWA';
import { useAuthStore } from 'store/auth';
import { showToast } from './CustomToast';
import { isCrushAppMobile } from 'utils/userAgentCheck';
import { Download } from 'components/icons/Download';

type Props = ButtonHTMLAttributes<HTMLButtonElement> & {
  showText?: boolean;
};

const PWAButton = ({ showText = true, ...rest }: Props) => {
  const [promptInstall, setPromptInstall] = useState<any | null>(null);
  const [isOpenInstallInstructions, setIsOpenInstallInstructions] = useState(false);
  const { isPWA } = useIsPWA();
  const { isLogged } = useAuthStore();

  useEffect(() => {
    const handler = (e: Event) => {
      e.preventDefault();
      setPromptInstall(e);
    };

    const installedHandler = () => {
      setPromptInstall(null);
    };

    window.addEventListener('beforeinstallprompt', handler);
    window.addEventListener('appinstalled', installedHandler);

    return () => {
      window.removeEventListener('beforeinstallprompt', handler);
      window.removeEventListener('appinstalled', installedHandler);
    };
  }, []);

  const onClick = (evt: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    evt.preventDefault();

    if (isCrushAppMobile()) {
      return;
    }

    if (osName === 'iOS') {
      window.open('https://apps.apple.com/us/app/krush-ai-girlfriend/id6741112370', '_blank');
      return;
    }

    if (promptInstall) {
      promptInstall.prompt();
      return;
    } else {
      showToast({
        message: 'Your browser does not support PWA installation or the app is already installed',
        type: 'error'
      });
    }
  };

  // Disable for now.
  // return <></>;

  return (
    // If currently in mobile app, skip
    // If currently in web, link to App Store if in iOS or use legacy
    <div className="flex justify-center items-center lg:hidden">
      {!isCrushAppMobile() && !isPWA && (
        <>
          {osName === 'iOS' ? (
            <>
              <button onClick={onClick} {...rest} style={{ width: '150px', margin: '0', padding: '0' }}>
                <img src="/app-store.png"
                  alt="Download on the App Store"/>
              </button>
              <span className="rounded-full font-light bg-brand p-1.5 m-1 text-xs">New!</span>
            </>
          ) : (
            <></>
            // <button onClick={onClick} {...rest}>
            //   <Download className="w-6 h-6" />
            //   {showText && <span className="text-sm font-medium">Install App</span>}
            // </button>
          )}
        </>
      )}

      {isOpenInstallInstructions && (
        <PWAInstructionModal
          onClose={() => {
            setIsOpenInstallInstructions(false);
            setPromptInstall(null);
          }}
        />
      )}
    </div>
  );
};

export default PWAButton;
